/**
 * "The sync status changed": said by whatever ran a sync, heard by whatever
 * shows the status (review SN-1, 2026-10-10).
 *
 * The banner above every screen polls on its own every five minutes, and the
 * Sync screen reads its own copy. After Sync Now the screen re-read and the
 * banner did not, so the banner went on saying "not synced yet ... Sync Now
 * runs it now" over a sync that had just run -- inviting a second press that
 * spends another of the hour's manual runs. CLAUDE.md: a screen that reads the
 * same fact twice must refresh both.
 *
 * A window event rather than a context, because the banner sits in the shell
 * and the screen in a route below it, and nothing else needs to share state.
 */

const EVENT = 'techne-books:sync-changed';

export function announceSyncChanged(): void {
  window.dispatchEvent(new Event(EVENT));
}

/** Calls `listener` on every announcement; returns the way to stop. */
export function onSyncChanged(listener: () => void): () => void {
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
